// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FeedbackModalHeader_wrapper__240tR","text":"FeedbackModalHeader_text__2hHct","title":"FeedbackModalHeader_title__5CW6A"};